import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `PowerOfficeGoIntegration` is a concrete implementation of
 * `AbstractIntegration` for import made with PowerOffice Go.
 *
 */
export default class PowerOfficeGoIntegration extends AbstractIntegration {
	isBeta() {
		return false;
	}

	getName() {
		return "PowerOffice Go";
	}

	routeName() {
		return "poweroffice-go";
	}

	canBeDisconnected() {
		return true;
	}

	isPowerOfficeGoIntegration() {
		return true;
	}

	static getType() {
		return "PowerOfficeGoIntegration";
	}
}
